// extracted by mini-css-extract-plugin
module.exports = {"preamble":"Preamble_preamble__g_itZ"};